import { render, staticRenderFns } from "./ExternalOrderProvidersForm.vue?vue&type=template&id=b511e1b8"
import script from "./ExternalOrderProvidersForm.vue?vue&type=script&lang=ts"
export * from "./ExternalOrderProvidersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports